import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Support: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.196 1.03361C8.22907 1.33642 5.66282 3.27569 4.56041 6.04801C4.21733 6.91078 4.0081 7.93577 4.00802 8.75401L4.008 9.00001H2.004H0V13.5V18H2.99933H5.99863L6.00641 13.218C6.01493 7.97204 6.0048 8.34437 6.15715 7.6651C6.65582 5.44169 8.44166 3.65583 10.6651 3.15718C11.1769 3.04239 11.4222 3.01654 12 3.01654C12.5778 3.01654 12.8231 3.04239 13.3349 3.15718C15.5575 3.65564 17.3445 5.44306 17.8431 7.66642C17.9968 8.35155 17.988 8.01757 17.988 13.164C17.988 18.1784 17.9925 17.982 17.8667 18.4832C17.6059 19.5217 16.9353 20.4063 15.9876 20.9619C15.4986 21.2486 14.7353 21.4779 14.265 21.4796C14.1973 21.4798 14.1083 21.4867 14.067 21.495L13.992 21.51V22.5067V23.5034L14.322 23.4883C14.7378 23.4693 15.0661 23.4205 15.487 23.315C15.9163 23.2074 16.2006 23.1015 16.6469 22.8828C18.1835 22.1298 19.3361 20.7392 19.7868 19.0945C19.865 18.8095 19.9588 18.3127 19.9732 18.108L19.98 18.012L21.996 18L24.012 17.988L24.0181 13.488L24.0241 8.98801L22.0116 8.99427L19.9991 9.00053L19.985 8.61027C19.9132 6.63058 19.0376 4.68111 17.5888 3.27526C16.3506 2.07373 14.8824 1.34789 13.14 1.07593C12.8917 1.03717 12.6834 1.02562 12.12 1.01941C11.7306 1.01511 11.3148 1.02149 11.196 1.03361ZM0.01176 13.5C0.01176 15.9816 0.014568 17.0004 0.018 15.7639C0.021432 14.5275 0.021432 12.4971 0.018 11.2519C0.014568 10.0068 0.01176 11.0184 0.01176 13.5ZM2.00306 11.022C1.99678 11.0385 1.99442 12.1644 1.99781 13.524L2.004 15.996L2.994 16.0023L3.984 16.0085V13.5003V10.992H2.99926C2.23354 10.992 2.01194 10.9987 2.00306 11.022ZM20.016 13.5V16.0085L21.006 16.0023L21.996 15.996V13.5V11.004L21.006 10.9977L20.016 10.9915V13.5Z'
        fill={fill}
      />
    </svg>
  )
}

export default Support
